import { Container as MantineContainer } from "@mantine/core";

export const Container = MantineContainer;
